import React from 'react'
import PropTypes from 'prop-types'
import createStyles from './styles'
import { css } from 'aphrodite'
import { Link } from './Link'

export class Button extends React.PureComponent {
  render() {
    const styles = getStyles(this.props, this.context)

    return this.props.to ? (
      <Link to={this.props.to} {...this.props} className={styles.root}>
        {this.props.children}
      </Link>
    ) : (
      <button type="submit" {...this.props} className={css(styles.root)}>
        {this.props.children}
      </button>
    )
  }
}

Button.contextTypes = {
  theme: PropTypes.object,
}

const getStyles = createStyles((props, context, theme) => ({
  root: {
    background:
      'linear-gradient(347deg, ' +
      theme.colors.buttonGradientStart +
      ', ' +
      theme.colors.buttonGradientEnd +
      ')',
    border: 0,
    borderRadius: 50,
    color: theme.colors.foreground,
    cursor: props.disabled ? 'not-allowed' : 'pointer',
    display: 'block',
    fontSize: 16,
    letterSpacing: 2,
    opacity: props.disabled ? 0.5 : undefined,
    padding: 20,
    outline: 0,
    textAlign: 'center',
    textTransform: 'uppercase',
    width: '100%',
    boxShadow: '0 20px 40px -15px rgba(61,133,255, 0.5)',

    ...(!props.disabled && {
      ':hover': {
        background: theme.colors.buttonGradientStart,
        textDecoration: 'none',
      },
    }),
  },
}))



// WEBPACK FOOTER //
// ./src/components/Button.js